import script from "./NewMembershipModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewMembershipModal.vue?vue&type=script&lang=ts&setup=true"

import "./NewMembershipModal.vue?vue&type=style&index=0&id=1a155613&lang=scss&scoped=true"
script.__scopeId = "data-v-1a155613"

export default script